import React from 'react'
import PropTypes from 'prop-types'
import ClassDrawerHeaderLayout, {
  ContentWrapper,
  TitleWrapper,
} from '../Layout'
import {
  ClassInfoText,
  ClassTitle,
  LessonsComplete,
} from '../ReportsClassHeader/component.styles'
import { pluralizeWord } from 'utils/stringHelpers'

/**
 * Tier2 interventions context header for class drawer.
 * Displays group information with simplified lesson completion summary.
 */
const Tier2ClassHeader = ({
  classTitle,
  fixedTop,
  fixedView,
  gradeName,
  lessonsCompleted,
  teacherFirstName,
  teacherLastName,
}) => {
  // Ensure gradeName has a fallback if undefined
  const displayGradeName =
    gradeName && gradeName !== 'undefined' ? gradeName : ''
  const teacherName = `${teacherFirstName || ''} ${teacherLastName ||
    ''}`.trim()
  const learnerGradeText = displayGradeName
    ? `${teacherName} • ${displayGradeName}`
    : teacherName

  // Match ReportsClassHeader format: "Class: {classTitle}"
  const classHeaderTitle = `Class: ${classTitle || ''}`
  const fixedViewLearnerGradeText = fixedView
    ? `Class: ${classTitle || ''} • ${learnerGradeText}`
    : learnerGradeText
  const classInfoText = fixedView ? fixedViewLearnerGradeText : learnerGradeText

  // Format: "<count> lesson(s) marked done" (no "of <total>")
  const lessonCount = lessonsCompleted || 0
  const lessonWord = pluralizeWord(lessonCount, 'lesson', 'lessons')
  const lessonsCompleteText = `${lessonCount} ${lessonWord} marked done`

  return (
    <ClassDrawerHeaderLayout fixedTop={fixedTop} fixedView={fixedView}>
      <ContentWrapper>
        <TitleWrapper>
          {!fixedView && (
            <ClassTitle dataTestId="class-title">{classHeaderTitle}</ClassTitle>
          )}
          <ClassInfoText data-testid="class-info-text">
            {classInfoText}
          </ClassInfoText>
        </TitleWrapper>
        <LessonsComplete data-testid="lessons-complete">
          {lessonsCompleteText}
        </LessonsComplete>
      </ContentWrapper>
    </ClassDrawerHeaderLayout>
  )
}

Tier2ClassHeader.propTypes = {
  classTitle: PropTypes.string.isRequired,
  fixedTop: PropTypes.bool,
  fixedView: PropTypes.bool,
  gradeName: PropTypes.string.isRequired,
  lessonsCompleted: PropTypes.number.isRequired,
  teacherFirstName: PropTypes.string.isRequired,
  teacherLastName: PropTypes.string.isRequired,
}

export default Tier2ClassHeader
